/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'aiAgentTeams';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'ai/agentTeam';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'aiAgentTeam';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'aiAgentTeams';
